// Game Configuration
export const CONFIG = {
  FOOD_PER_WORKER: 1,
  STARTING_FOOD: 10,
  STARTING_WOOD: 5,
  STARTING_STONE: 2,
  STARTING_METAL: 0,
  STARTING_KNOWLEDGE: 0,
  STARTING_MORALE: 50,
  STARTING_TECH_POINTS: 0,
  STARTING_WORKERS: 3,
  WIN_DAY: 50,
  BUILD_THRESHOLD: 10,
  PUSH_INJURY_THRESHOLD: 2,
  KNOWLEDGE_CAP: 100,
  MORALE_DEFECTION_THRESHOLD: 40,
  // New config for task system features
  CAVE_IN_THRESHOLD: 2,        // Mine task: rolls 1-2 cause cave-ins
  DISEASE_CHANCE_PER_DAY: 5,   // 5% base chance of disease outbreak per day
  TREAT_HEAL_CHANCE: 40,       // 40% chance to heal sick worker per treating worker
  SICK_WORKER_PRODUCTIVITY: 0, // Sick workers cannot work
  // Trade exchange rates (1 unit of key → value units of target resource)
  TRADE_EXCHANGE_RATES: {
    food: { wood: 2, stone: 3, metal: 4 },
    wood: { food: 0.5, stone: 1.5, metal: 2 },
    stone: { food: 0.33, wood: 0.67, metal: 1.5 },
    metal: { food: 0.25, wood: 0.5, stone: 0.67 }
  }
};

// Task types - generated from task definitions
import { TASK_DEFINITIONS } from './tasks.js';
export const TASKS = Object.keys(TASK_DEFINITIONS);

// Event definitions
export const EVENTS = [
  { roll: [1, 2], name: 'Raid NOW!', icon: '⚔️', type: 'raid', description: 'Raiders attack immediately!' },
  { roll: [3, 4], name: 'Raid Warning', icon: '🏴', type: 'warning', description: 'Raiders spotted! Attack tomorrow.' },
  { roll: [5, 6], name: 'Storm', icon: '⛈️', type: 'storm', description: 'Outdoor tasks yield nothing today.' },
  { roll: [7, 8], name: 'Spoilage', icon: '🪱', type: 'spoilage', description: 'Some food has rotted.' },
  { roll: [9, 14], name: 'Quiet Day', icon: '☀️', type: 'quiet', description: 'A peaceful day in the settlement.' },
  {
    roll: [15, 16],
    name: 'Traveler',
    icon: '🧳',
    type: 'traveler_choice',
    description: 'A wanderer offers to help. Will you invite them to stay permanently?',
    choices: [
      {
        id: 'temp',
        label: 'Accept Temporary Help',
        description: 'They work today and leave tomorrow (free)',
        effects: { tempWorker: true }
      },
      {
        id: 'recruit',
        label: 'Invite to Stay',
        description: 'Recruit them permanently',
        cost: { food: 5 },
        effects: {
          recruitTraveler: true,
          morale: 5
        }
      },
      {
        id: 'decline',
        label: 'Politely Decline',
        description: 'Send them on their way',
        effects: { morale: -2 }
      }
    ]
  },
  { roll: [17, 18], name: 'Good Weather', icon: '🌈', type: 'weather', description: 'Perfect conditions! All yields +2.' },
  { roll: [19, 20], name: 'Bounty', icon: '✨', type: 'bounty', description: 'Double one task\'s output!' }
];

// Initial game state factory
export const createInitialState = () => ({
  phase: 'event',
  day: 1,
  food: CONFIG.STARTING_FOOD,
  wood: CONFIG.STARTING_WOOD,
  stone: CONFIG.STARTING_STONE,
  metal: CONFIG.STARTING_METAL,
  knowledge: CONFIG.STARTING_KNOWLEDGE,
  morale: CONFIG.STARTING_MORALE,
  techPoints: CONFIG.STARTING_TECH_POINTS,
  workers: Array.from({ length: CONFIG.STARTING_WORKERS }, (_, i) => ({
    id: i + 1,
    status: 'healthy',
    type: 'worker',
    joinedOn: 1
  })),
  buildings: [],
  buildingInProgress: null,
  currentEvent: null,
  eventRoll: null,
  raidScheduledForDay: null, // null or day number when raid should occur
  raidWarning: false, // Keep for backward compatibility
  assignments: {},
  rolls: {},
  pushes: {},
  tempWorker: null,
  bountyTask: null,
  combatResult: null,
  gameOver: false,
  gameWon: false,
  message: null,
  deathLog: [],
  choicesMade: {},
  raidsDefeated: 0,
  lastAssignments: {}, // Remember worker assignments between days
  futureRefugees: null, // NEW: { day: X, count: Y }
  futureRefugeesArrivalNotice: null, // NEW: notification object
  secondaryEvents: [], // NEW: births, arrivals, etc.
  buildingCostReduction: null // NEW: 0.2 = 20% discount on next building
});
